import { useCallback, useState, VFC } from 'react';
import { useDispatch } from 'react-redux';
import { TextInput } from '../components/Uikit/TextInput';
import { PrimaryButton } from '../components/Uikit/PrimaryButton';
import { PrimaryOutlineButton } from '../components/Uikit/PrimaryOutlineButton';
import { signInOperation } from '../reducks/users/operations';
import { useNavigate } from 'react-router-dom';

const SignIn: VFC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // メールアドレス
  const [email, setEmail] = useState<string>('');
  // パスワード
  const [password, setPassword] = useState<string>('');

  /**
   * 入力されたメールアドレスをセット.
   */
  const inputEmail = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );
  /**
   * 入力されたパスワードをセット.
   */
  const inputPassword = useCallback(
    (e) => {
      setPassword(e.target.value);
    },
    [setPassword]
  );

  const handleSignIn = async () => {
    try {
      await dispatch(signInOperation(email, password, navigate));
    } catch (error) {
      console.error('Sign in failed:', error);
    }
  }

  return (
    <div className='mx-auto my-0 max-w-md p-4 h-auto w-[calc(100%_-_2rem)]'>
      <h2 className='text-pandacco text-2xl mt-0 mx-auto mb-12 text-center'>
        ログイン
      </h2>
      <TextInput
        fullWidth={true}
        label={'メールアドレス'}
        multiline={false}
        required={false}
        rows={1}
        value={email}
        type={'email'}
        onChange={inputEmail}
      />
      <TextInput
        fullWidth={true}
        label={'パスワード'}
        multiline={false}
        required={false}
        rows={1}
        value={password}
        type={'password'}
        onChange={inputPassword}
      />
      <div className='mx-auto my-0 text-right'>
        <p onClick={() => navigate('/signin/resetPassword')} className='cursor-pointer underline hover:opacity-70'>
          パスワードをお忘れですか？
        </p>
      </div>
      <div className='h-8 sm:h-12' />
      <div className='mx-auto my-0 text-center'>
        <PrimaryButton
          label='ログイン'
          onClick={handleSignIn}
        />
        <PrimaryOutlineButton label={'新規登録'} onClick={() => navigate('/signup')} />
      </div>
    </div>
  );
};

export default SignIn;
